import { Navigation } from "lucide-react";
import { SITE, waLink, mapsDirectionsUrl } from "@/config/site";
import { Reveal } from "@/components/Reveal";
import { WhatsAppIcon } from "@/components/WhatsAppIcon";

export default function LocalCta() {
  return (
    <section className="py-8 sm:py-12" data-testid="local-cta-section" aria-label="Vieni a trovarci">
      <div className="container-x">
        <Reveal>
          <div className="relative overflow-hidden rounded-[2rem] bg-[#003fa8] px-6 py-16 text-center sm:rounded-[2.5rem] sm:px-12 sm:py-20 lg:py-24">
            <div
              aria-hidden="true"
              className="pointer-events-none absolute -top-32 left-1/2 h-96 w-[42rem] -translate-x-1/2 rounded-full bg-white/[0.07] blur-3xl"
            />
            <p className="eyebrow justify-center !text-white/70">06 · Vieni a trovarci</p>
            <h2 className="font-display mx-auto mt-5 max-w-3xl text-3xl font-bold leading-[1.1] tracking-[-0.02em] text-white sm:text-4xl lg:text-5xl">
              Passa a trovarci. Il consiglio giusto parte da una conversazione.
            </h2>
            <p className="mx-auto mt-6 max-w-md text-base text-white/75 sm:text-lg">
              {SITE.name}
              <br />
              {SITE.address}
            </p>
            <div className="mt-10 flex flex-col items-center justify-center gap-3 sm:flex-row">
              <a
                href={mapsDirectionsUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="directions-button"
                className="btn-white w-full sm:w-auto"
              >
                <Navigation className="h-4 w-4" />
                Indicazioni stradali
              </a>
              <a
                href={waLink()}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="local-whatsapp-button"
                className="btn-outline-white w-full sm:w-auto"
              >
                <WhatsAppIcon className="h-5 w-5" />
                Scrivici su WhatsApp
              </a>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
